import type { CartSummary } from '~/api/cart/types'

import type { Discount } from '../types/discount'

export function getPriceAfterDiscount(
  discount: Discount,
  cartSummary: CartSummary,
) {
  if (!discount.id) {
    return {
      amount: cartSummary.totalPrice,
      currency: cartSummary.totalListingsPrice.currency,
    }
  }

  return {
    amount: String(discount.deductedPrice),
    currency: cartSummary.totalListingsPrice.currency,
  }
}
